import { combineReducers } from 'redux';
//import mapReducer from '../../components/AzureMap/organisms/AzureMapContainer/AzureMap.reducer';
//import eventManagementReducer from '../../components/operator/EventManagement/organisms/EventManagement.reducer';
import configReducer from './Index.reducer';
import formChangeReducer from '../../components/public/SubscriberDataFeed/organisms/ConfigureDataFeedContainer/ConfigureDataFeed.reducer';

import availableDataFeedReducer from '../../components/public/SubscriberDataFeed/organisms/AvailableDataFeedContainer/AvailableDataFeed.reducer';
import subscribedDataFeedReducer from '../../components/public/SubscriberDataFeed/molecules/SubscribedFeedsContainer/SubscribedFeedsContainer.reducer';
//import alertEventsReducer from '../../components/operator/AlertsList/organisms/AlertsList.reducer';
/**
 * combining the all reducers
 */
const Reducers = combineReducers({
  //map: mapReducer,
  //eventManagement: eventManagementReducer,
  config: configReducer,
  isDatafeedFormChange: formChangeReducer,
  availableDataFeed: availableDataFeedReducer,
  subscribedDataFeed: subscribedDataFeedReducer,
  //alertListReducer: alertEventsReducer,
});

export default Reducers;
